import { whatsappLink } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";
import { motion } from "motion/react";

const ctaImage = "https://readdy.ai/api/search-image?query=Professional%20agricultural%20consultant%20in%20a%20green%20productive%20field%20at%20golden%20hour%2C%20examining%20healthy%20crops%2C%20premium%20photography%20with%20warm%20earth%20tones%20and%20soft%20green%20accents%2C%20cinematic%20depth%20of%20field%2C%20modern%20farming%20aesthetic%2C%20no%20text%20no%20logo&width=1200&height=500&seq=llk-farmer&orientation=landscape";

export default function CTAFinalSection() {
  return (
    <section id="contato" className="relative py-16 sm:py-20 md:py-28 bg-llk-cream">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <ScrollReveal>
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden">
            {/* Image */}
            <div className="relative h-[420px] sm:h-80 md:h-80 lg:h-96">
              <img
                src={ctaImage}
                alt="Produtor no campo"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-llk-dark via-llk-dark/70 sm:via-llk-dark/60 to-llk-dark/40 sm:to-llk-dark/30" />
            </div>

            {/* Content Overlay */}
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 sm:px-6">
              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.2 }}
                className="font-display text-lg sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white font-semibold mb-3 sm:mb-4 leading-tight"
              >
                Quer saber qual solução faz mais sentido
                <br className="hidden sm:block" />
                <span className="italic text-llk-gold"> para a sua lavoura?</span>
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.3 }}
                className="text-white/70 text-sm sm:text-base md:text-lg max-w-lg sm:max-w-xl mb-6 sm:mb-8 px-2"
              >
                Fale com a equipe da LLK e receba uma orientação inicial para entender quais tecnologias biológicas podem apoiar o manejo da sua cultura.
              </motion.p>
              <motion.a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.98 }}
                className="group inline-flex items-center justify-center gap-2 sm:gap-3 px-4 sm:px-6 py-3 sm:py-3.5 bg-llk-gold text-llk-dark text-sm sm:text-base font-semibold rounded-full hover:bg-white transition-all duration-300 animate-pulse-gold whitespace-normal sm:whitespace-nowrap w-full sm:w-auto"
              >
                <i className="ri-whatsapp-line text-lg sm:text-xl" />
                Chamar um especialista no WhatsApp
                <i className="ri-arrow-right-line text-base sm:text-lg transition-transform group-hover:translate-x-1" />
              </motion.a>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}